const powerMap = {
  // 就业扶贫管理系统
  form_gyxjdbfzb: 'HelpCP', // 扶贫结对帮扶管理
  form_jyfpjd: 'EmploymentBase', // 就业扶贫基地管理
  form_pkhxx: 'PoorInfo', // 一户一档信息管理

  // 数据分类采集系统
  Form_grxxcj: 'PoorLabor', // 个人信息采集管理
  form_gwxxgxqkb: 'JobUpdate', // 用工信息采集管理
  form_axdw: 'LoveUnit', // 爱心单位采集管理
  form_dlgkbb: 'MineOrg', // 独立工矿报表管理
  form_tyjryb: 'RetireSoldier', // 退役军人月报管理
  form_danweizp: 'hn-recruit-unit', // 单位招聘统计表
  form_ncldlzyjyhcyqkb: 'TransferJob', // 农村劳动力转移就业和创业情况表

  // 数据统计报表系统
  report_rsyw: 'System-query-map', // 人社业务报表
  report_grxx: 'System-query-map', // 个人信息报表
  report_grnlwhfx: 'System-query-map', // 个人年龄文化分析
  report_grjyfsfx: 'System-query-map', // 个人就业方式分析
  report_grjyqtfx: 'System-query-map', // 个人就业群体分析
  report_grjyqyfx: 'System-query-map', // 个人就业区域分析
  report_dwzpxqfx: 'System-query-map', // 单位招聘需求分析
  report_gqjgtxfx: 'System-query-map', // 供求结构体系分析

  // 补贴台账
  form_ygdxbttjb: 'TrainingWorkAllowance', // 以工代训补贴统计表
  form_ycxqzcybttjb: 'OnceSetupAllowance', // 一次性求职创业补贴统计表
  form_jtbttjb: 'TrafficAllowance', // 交通补贴统计表
  form_gwsbbttjb: 'SocialAllowance', // 岗位、社保补贴统计表
  form_pxbthshfbt: 'TrainingAllowance', // 培训补贴和生活费补贴
  form_btqkztjb: 'AllAllowanceReport', // 补贴情况总统计表

  // 工作台账
  form_gyxgwaztjb: 'PublicWelfareJob', // 公益性岗位安置统计表
  form_jyfpcjtjb: 'HelpPoorWorkshop', // 就业扶贫车间统计表
  form_rycctjb: 'PersonCheck', // 人员抽查统计表
  form_mbrwtjb: 'TargetTask', // 目标任务统计表
  form_rlzysczytjb: 'ResourceMarket', // 人力资源市场主要统计表
  form_nclwjjr: 'VillageAgent', // 农村劳务经纪人统计表
  form_nclwjjrbtsb: 'VillageAgentApplyAllowance', // 农村劳务经纪人补贴申报统计表
  form_rlzyfwjg: 'ResourceOrganization', // 人力资源服务机构统计表
  form_rlzyfwjgbtsb: 'ResourceAllowance', // 人力资源服务机构补贴申报统计
  form_jycyfwbttjb: 'ResourceAllowanceReport', // 就业创业服务补贴统计表(导出)
  form_gwcctjb: 'JobCheck', // 岗位抽查统计表
  form_czsyrytjb: 'LostJobPerson', // 城镇失业人员统计表

  // 就业日志管理系统
  log: 'ServiceLog-HelpCp-Search', // 结对帮扶管理
  log1: 'ServiceLog-Info-Search', // 信息采集管理
  log2: 'ServiceLog-Job-Search', // 就业服务管理
  log3: 'ServiceLog-Trainging-Search', // 培训服务管理
  log4: 'ServiceLog-Pioneer-Search', // 创业服务管理
  log5: 'ServiceLog-Privilege-Search', // 维权服务管理
  log6: 'ServiceLog-Other-Search', // 其他服务管理
  log_shengcha: 'audit_help_log', // 服务日志审计

  // 现场远程创业系统
  form_jyfpcjjbqkzb: 'BobaiHelpPoorWorkShop', // 就业扶贫车间基本情况汇总表
  form_jyfpcjxnjymc: 'BobaiPoorlabor', // 就业扶贫车间吸纳就业名册汇总表
  form_jyfpcjdtgl: 'BobaiHelpPoorManage', // 就业扶贫车间动态管理台帐
  form_xnpkldljydtjgtz: 'BobaiPoorRecord', // 吸纳贫困劳动力就业动态监管台账
  form_xnydbqpkndl: 'BobaiTransfer', // 吸纳易地变迁贫困劳动力就业名册

  // 远程培训服务系统
  study: 'TrainingApply', // 培训上传
  studyUpload: 'Training-apply-upload', // 培训上传
  studyApply: 'Training-apply-request', // 培训申请
  studyExamine: 'Training-apply-audit', // 培训审核
  studyList: 'Training-apply-list', // 培训列表

  // 企业服务管理系统
  companyApply: 'apply-to-organization', // 企业申请审核
  jiaoyu: 'Education', // 教育服务列表
  peixun: 'Training', // 培训服务列表
  zhaoshang: 'AttractInvestment', // 招商服务列表
  jiameng: 'JoinIn', // 加盟服务列表
  rongzi: 'Finance', // 融资服务列表
  touzi: 'Investment', // 投资服务列表
  zufang: 'RentHouse', // 租房服务列表
  shoufang: 'SaleHouse', // 售房服务列表
  qiche: 'Car', // 汽车服务列表
  jiaoyou: 'Friends', // 交友服务列表
  gouwu: 'Shop', // 电商服务列表
  meishi: 'Food', // 美食服务列表
  lvyou: 'Tour', // 旅游服务列表
  jiankang: 'Health', // 健康服务列表
  // 视频招聘求职系统
  qiuzhi: 'qiuzhi', // 求职
  zhaopin1: 'zhaopin', // 招聘

  // 人岗自动匹配系统
  lookInterview: 'serivice-audit-interview', // 查看面试邀请
  lookResume: 'service-audit-receive-resume', // 查看简历投递

  // 法律维权管理系统
  flzx: 'layer-service', // 法律咨询
  ajwt: 'case-entrust', // 案件委托
  layerApply: 'layer-apply-audit', // 律师申请审核

  // 信息发布管理系统
  briefIntroduction: 'About-jin-cheng-modify', // 竞成简介
  idea: 'Idea-jin-cheng-modify', // 竞成理念
  culture: 'Culture-jin-cheng-modify', // 竞成文化
  team: 'Team-jin-cheng-modify', // 竞成团队
  routeLine: 'Road-jin-cheng-modify', // 竞成之路
  contactUs: 'Contact-jin-cheng-modify', // 联系我们
  news: 'News-jin-cheng-modify', // 竞成新闻
  activity: 'Activity-jin-cheng-modify', // 竞成活动
  overallArticle: 'global-news', // 竞成声明和帮助

  // 人事人才管理系统
  banner_rs: 'carousel-person', // 人事服务轮播管理
  banner_xw: 'carousel-person', // 新闻中心轮播管理
  examination: 'Person-zhao-kao', // 人事招考
  archives: 'Person-document', // 人事档案
  information: 'Person-information', // 人事信息
  train: 'Person-training', // 人事培训
  notice: 'Person-notice', // 才市预告
  scene: 'Person-hire', // 现场招聘
  video: 'Person-hire-video', // 视频招聘
  interview: 'Person-online-interview', // 在线访谈
  interviewNotice: 'Person-pre-interview', // 访谈预告
  interviewRecording: 'Person-interview-recording', // 访谈录播
  leaderEmail: 'Person-leader-email', // 领导信箱
  knowAll: 'Person-anything', // 百事通
  newsCenter: 'Person-news', // 新闻中心

  // 交流投诉管理系统
  communication: 'OnlineMessage', // 交流管理
  complaint: 'complaint', // 投诉管理

  // 个人社保服务系统
  shebao_geren: 'person-insurance-base-info', // 个人社保信息管理
  shebao_weizhuanyi: 'un-transfer-insurance', // 未转移社保管理
  shebao_bujiaofei: 'add-payment', // 社保补缴费管理
  shebao_jiaona: 'Insurance', // 缴纳情况管理
  shebao_tuifei: 'InsuranceYear', // 社保退费管理

  fenpeigeren: 'assign-user-to-work-person', // 分配个人信息
  fenpeiqiye: 'assign-organization-to-work-person', // 分配企业信息

  // 工作人员服务系统
  fapiao: 'invoice-apply', // 发票管理

  // 人力资源管理系统
  rlzy_guanlian_qiye: 'CooperateOrganization', // 关联企业管理
  rlzy_guanlian_geren: 'CooperateUser', // 关联个人管理
  rlzy_guanlian_hetong: 'OrganizationContract', // 关联企业管理 合同
  rlzy_guanlian_gerenhetong: 'UserContract', // 关联企业管理 个人合同
  rlzy_dengji_hesuan: 'Gift', // 费用核算发放登记
  rlzy_dengji_kaipiao: 'Invoice', // 开票登记
  rlzy_dengji_daozhang: 'Income', // 到账登记

  // 建筑工地管理系统
  jzgd_zaixianqiuzhu: 'OnlineHelp', // 在线求助
  jzgd_zaixianqiuzhuM: 'OnlineHelp', // 在线求助管理
  jzgd_yonggongbeian: 'LaborRecord', // 劳动用工备案

  // 人社数据同步系统
  shengting_qiye: 'sync-company', // 企业信息
  shengting_gangwei: 'sync-job', // 岗位信息
  shengting_zhaopinhui: 'sync-hire', // 招聘会信息
  shengting_zhaopingangwei: 'sync-hire-job', // 招聘会招聘岗位信息
  rensheyewu: 'service-social-url', // 人社业务

  quickqiuzhi: 'quick_find_job', // 快速求职

  // 系统设置管理系统
  logo: 'System-setting-name-logo', // 分站设置
  mapSet: 'System-map-logo', // 地图信息
  mapView: 'System-query-map', // 查看地图
  areaedit: 'System-area-logo', // 地区修改
  setKeyWord: 'global-comments', // 设置评论敏感词
  setSitePower: 'service-user-privilege', // 站点管理权限
  fenzhan: 'service-create-user', // 创建用户
  delUser: 'service-delete-user', // 删除用户
  power: 'System-privilege', // 权限和密码设置
  zhiding: 'user-show', // 置顶权重设置
  setVip: 'user-vip', // vip设置
  vip: 'Apply-To-Vip', // VIP申请管理
  zhengce: 'System-policy', // 政策法规
  userInfo: 'user-info', // 账号信息修改
  renshe: 'System-social', // 人社业务


  zhaopin: 'JobUpdate', // 用工信息采集
  gwxxgxqkb: 'JobUpdate', // 用工信息采集

  qiyesq: 'apply-to-organization', // 企业申请审核

  tousu: 'complaint', // 投诉 删改查
  hudong: 'OnlineMessage', // 互动
  banner: 'carousel-person', // 轮播 增删改查
  mianshi: 'serivice-audit-interview', // 查看面试邀请 查（删）
  jianli: 'service-audit-receive-resume', // 查看简历投递 查（删）
  zixun: 'layer-service', // 法律咨询 删改查
  weituo: 'case-entrust', // 案件委托 删改查
  
  wz_guanyu: 'About-jin-cheng-modify', // 关于竞成
  wz_linian: 'Idea-jin-cheng-modify', // 竞成理念
  wz_wenhua: 'Culture-jin-cheng-modify', // 竞成文化
  wz_tuandui: 'Team-jin-cheng-modify', // 竞成团队
  wz_zhilu: 'Road-jin-cheng-modify', // 竞成之路
  wz_lianxi: 'Contact-jin-cheng-modify', // 联系我们
  wz_xinwen: 'News-jin-cheng-modify', // 竞成新闻
  wz_huodong: 'Activity-jin-cheng-modify', // 竞成活动
  wz_quanju: 'global-news', // 全局新闻

  vipsq: 'Apply-To-Vip', // VIP申请

  // 法律援助管理系统
  yz_wt_weituo: 'Encase-Contract', // 委托合同
  yz_wt_fapiao: 'Entrust-invoice', // 发票申领
  yz_tj_tiaojie: 'Encase-Contract', // 调解申请
  yz_ss_baoquan: 'Encase-Contract', // 诉讼保全
  yz_ss_qubaohoushen: 'Encase-Contract', // 取保候审
  yz_ss_gongzheng: 'Encase-Contract', // 公证鉴定
  yz_ss_jinzhan: 'LitigationProgress', // 诉讼进展
  yz_ws_zhengju: 'LitigationDoc', // 证据资料上传
  yz_ws_caijue: 'LitigationDoc', // 裁判文书上传
  yz_ws_zongjie: 'LitigationDoc', // 案件总结上传
  yz_ws_guidang: 'LitigationDoc', // 案件资料归档

  // 人口进城管理系统
  questionnaire_jionCity: 'person-invest', // 人口进城调查

  // 残疾就业管理系统
  canjiren_jynldwjycjrzkdcb: 'deformed-man', // 就业年龄段未就业残疾人状况调查表

  // 退役军人管理系统
  tuiyijunren_tyjrjyqkcjb: 'defveterans-job', // 退役军人就业情况采集表
  tuiyijunren_tyjryb: 'RetireSoldier', // 退役军人月报管理
}

const powerData = [
  {id: 'Lose0',label: '巩固脱贫',
    children: [
      { id: 'Lose0_1', label: '结对帮扶权限管理', children:[
        // {id:powerMap.form_gyxjdbfzb, label:'结对帮扶'},
        {id:powerMap.form_gyxjdbfzb+'-search', label:'结对帮扶查询'},
        {id:powerMap.form_gyxjdbfzb+'-modify', label:'结对帮扶修改'},
        {id:powerMap.form_gyxjdbfzb+'-delete', label:'结对帮扶删除'},
        {id:powerMap.form_gyxjdbfzb+'-create', label:'结对帮扶创建'},
        {id:powerMap.form_gyxjdbfzb+'-import', label:'结对帮扶导入'},
        {id:powerMap.form_gyxjdbfzb+'-export', label:'结对帮扶导出'},
      ]},
      { id: 'Lose0_2', label: '就业基地权限管理', children:[
        // {id:powerMap.form_jyfpjd, label:'就业基地'},
        {id:powerMap.form_jyfpjd+'-search', label:'就业基地查询'},
        {id:powerMap.form_jyfpjd+'-modify', label:'就业基地修改'},
        {id:powerMap.form_jyfpjd+'-delete', label:'就业基地删除'},
        {id:powerMap.form_jyfpjd+'-create', label:'就业基地创建'},
        {id:powerMap.form_jyfpjd+'-import', label:'就业基地导入'},
        {id:powerMap.form_jyfpjd+'-export', label:'就业基地导出'},
      ]},
      { id: 'Lose0_3', label: '贫困户信息权限管理', children:[
        // {id:powerMap.form_pkhxx, label:'贫困户信息'},
        {id:powerMap.form_pkhxx+'-search', label:'贫困户信息查询'},
        {id:powerMap.form_pkhxx+'-modify', label:'贫困户信息修改'},
        {id:powerMap.form_pkhxx+'-delete', label:'贫困户信息删除'},
        {id:powerMap.form_pkhxx+'-create', label:'贫困户信息创建'},
        {id:powerMap.form_pkhxx+'-import', label:'贫困户信息导入'},
        {id:powerMap.form_pkhxx+'-export', label:'贫困户信息导出'},
      ]},
    ]
  },
  {id: 'Lose1',label: '数据分类采集',
    children: [
      { id: 'Lose1_1', label: '个人信息采集权限管理', children:[
        // {id:powerMap.Form_grxxcj, label:'个人信息采集'},
        {id:powerMap.Form_grxxcj+'-search', label:'个人信息采集查询'},
        {id:powerMap.Form_grxxcj+'-modify', label:'个人信息采集修改'},
        {id:powerMap.Form_grxxcj+'-delete', label:'个人信息采集删除'},
        {id:powerMap.Form_grxxcj+'-create', label:'个人信息采集创建'},
        {id:powerMap.Form_grxxcj+'-import', label:'个人信息采集导入'},
        {id:powerMap.Form_grxxcj+'-export', label:'个人信息采集导出'},
      ]},
      { id: 'Lose1_2', label: '用工信息采集权限管理', children:[
        // {id:powerMap.form_gwxxgxqkb, label:'用工信息采集'},
        {id:powerMap.form_gwxxgxqkb+'-search', label:'用工信息采集查询'},
        {id:powerMap.form_gwxxgxqkb+'-modify', label:'用工信息采集修改'},
        {id:powerMap.form_gwxxgxqkb+'-delete', label:'用工信息采集删除'},
        {id:powerMap.form_gwxxgxqkb+'-create', label:'用工信息采集创建'},
        {id:powerMap.form_gwxxgxqkb+'-import', label:'用工信息采集导入'},
        {id:powerMap.form_gwxxgxqkb+'-export', label:'用工信息采集导出'},
      ]},
      { id: 'Lose1_3', label: '爱心单位权限管理', children:[
        // {id:powerMap.form_axdw, label:'爱心单位'},
        {id:powerMap.form_axdw+'-search', label:'爱心单位查询'},
        {id:powerMap.form_axdw+'-modify', label:'爱心单位修改'},
        {id:powerMap.form_axdw+'-delete', label:'爱心单位删除'},
        {id:powerMap.form_axdw+'-create', label:'爱心单位创建'},
        {id:powerMap.form_axdw+'-import', label:'爱心单位导入'},
        {id:powerMap.form_axdw+'-export', label:'爱心单位导出'},
      ]},
      { id: 'Lose1_4', label: '独立工矿权限管理', children:[
        // {id:powerMap.form_dlgkbb, label:'独立工矿'},
        {id:powerMap.form_dlgkbb+'-search', label:'独立工矿查询'},
        {id:powerMap.form_dlgkbb+'-modify', label:'独立工矿修改'},
        {id:powerMap.form_dlgkbb+'-delete', label:'独立工矿删除'},
        {id:powerMap.form_dlgkbb+'-create', label:'独立工矿创建'},
        {id:powerMap.form_dlgkbb+'-import', label:'独立工矿导入'},
        {id:powerMap.form_dlgkbb+'-export', label:'独立工矿导出'},
      ]},
      // { id: 'Lose1_5', label: '退役军人权限管理', children:[
      //   // {id:powerMap.form_tyjryb, label:'退役军人'},
      //   {id:powerMap.form_tyjryb+'-search', label:'退役军人查询'},
      //   {id:powerMap.form_tyjryb+'-modify', label:'退役军人修改'},
      //   {id:powerMap.form_tyjryb+'-delete', label:'退役军人删除'},
      //   {id:powerMap.form_tyjryb+'-create', label:'退役军人创建'},
      //   {id:powerMap.form_tyjryb+'-import', label:'退役军人导入'},
      //   {id:powerMap.form_tyjryb+'-export', label:'退役军人导出'},
      // ]},
      { id: 'Lose1_6', label: '劳动力转移权限管理', children:[
        // {id:powerMap.form_ncldlzyjyhcyqkb, label:'劳动力转移'},
        {id:powerMap.form_ncldlzyjyhcyqkb+'-search', label:'劳动力转移查询'},
        {id:powerMap.form_ncldlzyjyhcyqkb+'-modify', label:'劳动力转移修改'},
        {id:powerMap.form_ncldlzyjyhcyqkb+'-delete', label:'劳动力转移删除'},
        {id:powerMap.form_ncldlzyjyhcyqkb+'-create', label:'劳动力转移创建'},
        {id:powerMap.form_ncldlzyjyhcyqkb+'-import', label:'劳动力转移导入'},
        {id:powerMap.form_ncldlzyjyhcyqkb+'-export', label:'劳动力转移导出'},
      ]},
    ]
  },
  {id: 'Lose2',label: '人社业务',
    children: [
      {id: powerMap.shengting_qiye,label: '同步企业信息'},
      {id: powerMap.shengting_qiye+'-export',label: '同步企业信息导出'},
      {id: powerMap.shengting_qiye+'-delete',label: '同步企业信息删除'},
      {id: powerMap.shengting_gangwei,label: '同步岗位信息'},
      {id: powerMap.shengting_gangwei+'-export',label: '同步岗位信息导出'},
      {id: powerMap.shengting_gangwei+'-delete',label: '同步岗位信息删除'},
      {id: powerMap.shengting_zhaopinhui,label: '同步招聘会信息'},
      {id: powerMap.shengting_zhaopinhui+'-export',label: '同步招聘会信息导出'},
      {id: powerMap.shengting_zhaopinhui+'-delete',label: '同步招聘会信息删除'},
      {id: powerMap.shengting_zhaopingangwei,label: '同步招聘会岗位信息'},
      {id: powerMap.shengting_zhaopingangwei+'-export',label: '同步招聘会岗位信息导出'},
      {id: powerMap.shengting_zhaopingangwei+'-delete',label: '同步招聘会岗位信息删除'},
      {id: powerMap.rensheyewu, label: '人社业务'},
    ]
  },
  {id: 'Lose23',label: '残疾就业',
    children: [
      {id: 'deformed-man',label: '就业年龄段未就业残疾人状况调查表', children:[
        // {id:powerMap.canjiren_jynldwjycjrzkdcb, label:'就业年龄段未就业残疾人状况调查表'},
        {id:powerMap.canjiren_jynldwjycjrzkdcb+'-search', label:'就业年龄段未就业残疾人状况调查表查询'},
        {id:powerMap.canjiren_jynldwjycjrzkdcb+'-modify', label:'就业年龄段未就业残疾人状况调查表修改'},
        {id:powerMap.canjiren_jynldwjycjrzkdcb+'-delete', label:'就业年龄段未就业残疾人状况调查表删除'},
        {id:powerMap.canjiren_jynldwjycjrzkdcb+'-create', label:'就业年龄段未就业残疾人状况调查表创建'},
        {id:powerMap.canjiren_jynldwjycjrzkdcb+'-import', label:'就业年龄段未就业残疾人状况调查表导入'},
        {id:powerMap.canjiren_jynldwjycjrzkdcb+'-export', label:'就业年龄段未就业残疾人状况调查表导出'},
      ]},
    ]
  },
  {id: 'Lose24',label: '退役军人',
    children: [
      {id: 'veterans-job',label: '退役军人就业情况采集表', children:[
        // {id:powerMap.tuiyijunren_tyjrjyqkcjb, label:'退役军人就业情况采集表'},
        {id:powerMap.tuiyijunren_tyjrjyqkcjb+'-search', label:'退役军人就业情况采集表查询'},
        {id:powerMap.tuiyijunren_tyjrjyqkcjb+'-modify', label:'退役军人就业情况采集表修改'},
        {id:powerMap.tuiyijunren_tyjrjyqkcjb+'-delete', label:'退役军人就业情况采集表删除'},
        {id:powerMap.tuiyijunren_tyjrjyqkcjb+'-create', label:'退役军人就业情况采集表创建'},
        {id:powerMap.tuiyijunren_tyjrjyqkcjb+'-import', label:'退役军人就业情况采集表导入'},
        {id:powerMap.tuiyijunren_tyjrjyqkcjb+'-export', label:'退役军人就业情况采集表导出'},
      ]},
      {id: 'RetireSoldier',label: '退役军人月报管理', children:[
        // {id:powerMap.tuiyijunren_tyjryb, label:'退役军人月报管理'},
        {id:powerMap.tuiyijunren_tyjryb+'-search', label:'退役军人月报管理查询'},
        {id:powerMap.tuiyijunren_tyjryb+'-modify', label:'退役军人月报管理修改'},
        {id:powerMap.tuiyijunren_tyjryb+'-delete', label:'退役军人月报管理删除'},
        {id:powerMap.tuiyijunren_tyjryb+'-create', label:'退役军人月报管理创建'},
        {id:powerMap.tuiyijunren_tyjryb+'-import', label:'退役军人月报管理导入'},
        {id:powerMap.tuiyijunren_tyjryb+'-export', label:'退役军人月报管理导出'},
      ]},
    ]
  },
  {id: 'Lose22',label: '人口进城',
    children: [
      {id: 'person-invest',label: '人口进城调查', children:[
        // {id:powerMap.questionnaire_jionCity, label:'人口进城调查'},
        {id:powerMap.questionnaire_jionCity+'-search', label:'人口进城调查查询'},
        {id:powerMap.questionnaire_jionCity+'-modify', label:'人口进城调查修改'},
        {id:powerMap.questionnaire_jionCity+'-delete', label:'人口进城调查删除'},
        {id:powerMap.questionnaire_jionCity+'-create', label:'人口进城调查创建'},
        {id:powerMap.questionnaire_jionCity+'-import', label:'人口进城调查导入'},
        {id:powerMap.questionnaire_jionCity+'-export', label:'人口进城调查导出'},
      ]},
    ]
  },
  {id: 'Lose3',label: '补贴台账',
    children: [
      { id: 'Lose3_1', label: '以工代训补贴权限管理', children:[
        // {id:powerMap.form_ygdxbttjb, label:'以工代训补贴'},
        {id:powerMap.form_ygdxbttjb+'-search', label:'以工代训补贴查询'},
        {id:powerMap.form_ygdxbttjb+'-modify', label:'以工代训补贴修改'},
        {id:powerMap.form_ygdxbttjb+'-delete', label:'以工代训补贴删除'},
        {id:powerMap.form_ygdxbttjb+'-create', label:'以工代训补贴创建'},
        {id:powerMap.form_ygdxbttjb+'-import', label:'以工代训补贴导入'},
        {id:powerMap.form_ygdxbttjb+'-export', label:'以工代训补贴导出'},
      ]},
      { id: 'Lose3_2', label: '一次性求职创业补贴统计表权限管理', children:[
        // {id:powerMap.form_ycxqzcybttjb, label:'一次性求职创业补贴统计表'},
        {id:powerMap.form_ycxqzcybttjb+'-search', label:'一次性求职创业补贴统计表查询'},
        {id:powerMap.form_ycxqzcybttjb+'-modify', label:'一次性求职创业补贴统计表修改'},
        {id:powerMap.form_ycxqzcybttjb+'-delete', label:'一次性求职创业补贴统计表删除'},
        {id:powerMap.form_ycxqzcybttjb+'-create', label:'一次性求职创业补贴统计表创建'},
        {id:powerMap.form_ycxqzcybttjb+'-import', label:'一次性求职创业补贴统计表导入'},
        {id:powerMap.form_ycxqzcybttjb+'-export', label:'一次性求职创业补贴统计表导出'},
      ]},
      { id: 'Lose3_3', label: '交通补贴统计表权限管理', children:[
        // {id:powerMap.form_jtbttjb, label:'交通补贴统计表'},
        {id:powerMap.form_jtbttjb+'-search', label:'交通补贴统计表查询'},
        {id:powerMap.form_jtbttjb+'-modify', label:'交通补贴统计表修改'},
        {id:powerMap.form_jtbttjb+'-delete', label:'交通补贴统计表删除'},
        {id:powerMap.form_jtbttjb+'-create', label:'交通补贴统计表创建'},
        {id:powerMap.form_jtbttjb+'-import', label:'交通补贴统计表导入'},
        {id:powerMap.form_jtbttjb+'-export', label:'交通补贴统计表导出'},
      ]},
      { id: 'Lose3_4', label: '岗位、社保补贴统计表权限管理', children:[
        // {id:powerMap.form_gwsbbttjb, label:'岗位、社保补贴统计表'},
        {id:powerMap.form_gwsbbttjb+'-search', label:'岗位、社保补贴统计表查询'},
        {id:powerMap.form_gwsbbttjb+'-modify', label:'岗位、社保补贴统计表修改'},
        {id:powerMap.form_gwsbbttjb+'-delete', label:'岗位、社保补贴统计表删除'},
        {id:powerMap.form_gwsbbttjb+'-create', label:'岗位、社保补贴统计表创建'},
        {id:powerMap.form_gwsbbttjb+'-import', label:'岗位、社保补贴统计表导入'},
        {id:powerMap.form_gwsbbttjb+'-export', label:'岗位、社保补贴统计表导出'},
      ]},
      { id: 'Lose3_5', label: '培训补贴和生活费补贴权限管理', children:[
        // {id:powerMap.form_pxbthshfbt, label:'培训补贴和生活费补贴'},
        {id:powerMap.form_pxbthshfbt+'-search', label:'培训补贴和生活费补贴查询'},
        {id:powerMap.form_pxbthshfbt+'-modify', label:'培训补贴和生活费补贴修改'},
        {id:powerMap.form_pxbthshfbt+'-delete', label:'培训补贴和生活费补贴删除'},
        {id:powerMap.form_pxbthshfbt+'-create', label:'培训补贴和生活费补贴创建'},
        {id:powerMap.form_pxbthshfbt+'-import', label:'培训补贴和生活费补贴导入'},
        {id:powerMap.form_pxbthshfbt+'-export', label:'培训补贴和生活费补贴导出'},
      ]},
      { id: 'Lose3_6', label: '补贴情况总统计表权限管理', children:[
        // {id:powerMap.form_btqkztjb, label:'补贴情况总统计表'},
        {id:powerMap.form_btqkztjb+'-search', label:'补贴情况总统计表查询'},
        {id:powerMap.form_btqkztjb+'-modify', label:'补贴情况总统计表修改'},
        {id:powerMap.form_btqkztjb+'-delete', label:'补贴情况总统计表删除'},
        {id:powerMap.form_btqkztjb+'-create', label:'补贴情况总统计表创建'},
        {id:powerMap.form_btqkztjb+'-import', label:'补贴情况总统计表导入'},
        {id:powerMap.form_btqkztjb+'-export', label:'补贴情况总统计表导出'},
      ]},
    ]
  },
  {id: 'Lose4',label: '其它台账',
    children: [
      { id: 'Lose4_1', label: '公益性岗位安置统计表权限管理', children:[
        // {id:powerMap.form_gyxgwaztjb, label:'公益性岗位安置统计表'},
        {id:powerMap.form_gyxgwaztjb+'-search', label:'公益性岗位安置统计表查询'},
        {id:powerMap.form_gyxgwaztjb+'-modify', label:'公益性岗位安置统计表修改'},
        {id:powerMap.form_gyxgwaztjb+'-delete', label:'公益性岗位安置统计表删除'},
        {id:powerMap.form_gyxgwaztjb+'-create', label:'公益性岗位安置统计表创建'},
        {id:powerMap.form_gyxgwaztjb+'-import', label:'公益性岗位安置统计表导入'},
        {id:powerMap.form_gyxgwaztjb+'-export', label:'公益性岗位安置统计表导出'},
      ]},
      { id: 'Lose4_2', label: '就业扶贫车间权限管理', children:[
        // {id:powerMap.form_jyfpcjtjb, label:'就业扶贫车间'},
        {id:powerMap.form_jyfpcjtjb+'-search', label:'就业扶贫车间查询'},
        {id:powerMap.form_jyfpcjtjb+'-modify', label:'就业扶贫车间修改'},
        {id:powerMap.form_jyfpcjtjb+'-delete', label:'就业扶贫车间删除'},
        {id:powerMap.form_jyfpcjtjb+'-create', label:'就业扶贫车间创建'},
        {id:powerMap.form_jyfpcjtjb+'-import', label:'就业扶贫车间导入'},
        {id:powerMap.form_jyfpcjtjb+'-export', label:'就业扶贫车间导出'},
      ]},
      { id: 'Lose4_3', label: '人员抽查统计表权限管理', children:[
        // {id:powerMap.form_rycctjb, label:'人员抽查统计表'},
        {id:powerMap.form_rycctjb+'-search', label:'人员抽查统计表查询'},
        {id:powerMap.form_rycctjb+'-modify', label:'人员抽查统计表修改'},
        {id:powerMap.form_rycctjb+'-delete', label:'人员抽查统计表删除'},
        {id:powerMap.form_rycctjb+'-create', label:'人员抽查统计表创建'},
        {id:powerMap.form_rycctjb+'-import', label:'人员抽查统计表导入'},
        {id:powerMap.form_rycctjb+'-export', label:'人员抽查统计表导出'},
      ]},
      { id: 'Lose4_4', label: '目标任务统计表权限管理', children:[
        // {id:powerMap.form_mbrwtjb, label:'目标任务统计表'},
        {id:powerMap.form_mbrwtjb+'-search', label:'目标任务统计表查询'},
        {id:powerMap.form_mbrwtjb+'-modify', label:'目标任务统计表修改'},
        {id:powerMap.form_mbrwtjb+'-delete', label:'目标任务统计表删除'},
        {id:powerMap.form_mbrwtjb+'-create', label:'目标任务统计表创建'},
        {id:powerMap.form_mbrwtjb+'-import', label:'目标任务统计表导入'},
        {id:powerMap.form_mbrwtjb+'-export', label:'目标任务统计表导出'},
      ]},
      { id: 'Lose4_5', label: '人力资源市场主要统计表权限管理', children:[
        // {id:powerMap.form_rlzysczytjb, label:'人力资源市场主要统计表'},
        {id:powerMap.form_rlzysczytjb+'-search', label:'人力资源市场主要统计表查询'},
        {id:powerMap.form_rlzysczytjb+'-modify', label:'人力资源市场主要统计表修改'},
        {id:powerMap.form_rlzysczytjb+'-delete', label:'人力资源市场主要统计表删除'},
        {id:powerMap.form_rlzysczytjb+'-create', label:'人力资源市场主要统计表创建'},
        {id:powerMap.form_rlzysczytjb+'-import', label:'人力资源市场主要统计表导入'},
        {id:powerMap.form_rlzysczytjb+'-export', label:'人力资源市场主要统计表导出'},
      ]},
      { id: 'Lose4_6', label: '农村经纪人权限管理', children:[
        // {id:powerMap.form_nclwjjr, label:'农村经纪人'},
        {id:powerMap.form_nclwjjr+'-search', label:'农村经纪人查询'},
        {id:powerMap.form_nclwjjr+'-modify', label:'农村经纪人修改'},
        {id:powerMap.form_nclwjjr+'-delete', label:'农村经纪人删除'},
        {id:powerMap.form_nclwjjr+'-create', label:'农村经纪人创建'},
        {id:powerMap.form_nclwjjr+'-import', label:'农村经纪人导入'},
        {id:powerMap.form_nclwjjr+'-export', label:'农村经纪人导出'},
      ]},
      { id: 'Lose4_7', label: '农村劳务经纪人补贴申报统计表权限管理', children:[
        // {id:powerMap.form_nclwjjrbtsb, label:'农村劳务经纪人补贴申报统计表'},
        {id:powerMap.form_nclwjjrbtsb+'-search', label:'农村劳务经纪人补贴申报统计表查询'},
        {id:powerMap.form_nclwjjrbtsb+'-modify', label:'农村劳务经纪人补贴申报统计表修改'},
        {id:powerMap.form_nclwjjrbtsb+'-delete', label:'农村劳务经纪人补贴申报统计表删除'},
        {id:powerMap.form_nclwjjrbtsb+'-create', label:'农村劳务经纪人补贴申报统计表创建'},
        {id:powerMap.form_nclwjjrbtsb+'-import', label:'农村劳务经纪人补贴申报统计表导入'},
        {id:powerMap.form_nclwjjrbtsb+'-export', label:'农村劳务经纪人补贴申报统计表导出'},
      ]},
      { id: 'Lose4_8', label: '人力资源服务机构权限管理', children:[
        // {id:powerMap.form_rlzyfwjg, label:'人力资源服务机构'},
        {id:powerMap.form_rlzyfwjg+'-search', label:'人力资源服务机构查询'},
        {id:powerMap.form_rlzyfwjg+'-modify', label:'人力资源服务机构修改'},
        {id:powerMap.form_rlzyfwjg+'-delete', label:'人力资源服务机构删除'},
        {id:powerMap.form_rlzyfwjg+'-create', label:'人力资源服务机构创建'},
        {id:powerMap.form_rlzyfwjg+'-import', label:'人力资源服务机构导入'},
        {id:powerMap.form_rlzyfwjg+'-export', label:'人力资源服务机构导出'},
      ]},
      { id: 'Lose4_9', label: '人力资源服务机构补贴申报统计权限管理', children:[
        // {id:powerMap.form_rlzyfwjgbtsb, label:'人力资源服务机构补贴申报统计'},
        {id:powerMap.form_rlzyfwjgbtsb+'-search', label:'人力资源服务机构补贴申报统计查询'},
        {id:powerMap.form_rlzyfwjgbtsb+'-modify', label:'人力资源服务机构补贴申报统计修改'},
        {id:powerMap.form_rlzyfwjgbtsb+'-delete', label:'人力资源服务机构补贴申报统计删除'},
        {id:powerMap.form_rlzyfwjgbtsb+'-create', label:'人力资源服务机构补贴申报统计创建'},
        {id:powerMap.form_rlzyfwjgbtsb+'-import', label:'人力资源服务机构补贴申报统计导入'},
        {id:powerMap.form_rlzyfwjgbtsb+'-export', label:'人力资源服务机构补贴申报统计导出'},
      ]},
      { id: 'Lose4_10', label: '就业创业服务补贴统计表权限管理', children:[
        // {id:powerMap.form_jycyfwbttjb, label:'就业创业服务补贴统计表'},
        {id:powerMap.form_jycyfwbttjb+'-search', label:'就业创业服务补贴统计表查询'},
        {id:powerMap.form_jycyfwbttjb+'-export', label:'就业创业服务补贴统计表导出'},
      ]},
      { id: 'Lose4_11', label: '岗位抽查统计表权限管理', children:[
        // {id:powerMap.form_gwcctjb, label:'岗位抽查统计表'},
        {id:powerMap.form_gwcctjb+'-search', label:'岗位抽查统计表查询'},
        {id:powerMap.form_gwcctjb+'-modify', label:'岗位抽查统计表修改'},
        {id:powerMap.form_gwcctjb+'-delete', label:'岗位抽查统计表删除'},
        {id:powerMap.form_gwcctjb+'-create', label:'岗位抽查统计表创建'},
        {id:powerMap.form_gwcctjb+'-import', label:'岗位抽查统计表导入'},
        {id:powerMap.form_gwcctjb+'-export', label:'岗位抽查统计表导出'},
      ]},
      { id: 'Lose4_12', label: '城镇失业人员统计表权限管理', children:[
        // {id:powerMap.form_czsyrytjb, label:'城镇失业人员统计表'},
        {id:powerMap.form_czsyrytjb+'-search', label:'城镇失业人员统计表查询'},
        {id:powerMap.form_czsyrytjb+'-modify', label:'城镇失业人员统计表修改'},
        {id:powerMap.form_czsyrytjb+'-delete', label:'城镇失业人员统计表删除'},
        {id:powerMap.form_czsyrytjb+'-create', label:'城镇失业人员统计表创建'},
        {id:powerMap.form_czsyrytjb+'-import', label:'城镇失业人员统计表导入'},
        {id:powerMap.form_czsyrytjb+'-export', label:'城镇失业人员统计表导出'},
      ]},
    ]
  },
  {id: 'Lose5',label: '日志管理',
    children: [
      { id: powerMap.log, label: '结对帮扶权限管理'},
      { id: powerMap.log1, label: '信息采集管理'},
      { id: powerMap.log2, label: '就业服务管理'},
      { id: powerMap.log3, label: '培训服务管理'},
      { id: powerMap.log4, label: '创业服务管理'},
      { id: powerMap.log5, label: '维权服务管理'},
      { id: powerMap.log6, label: '其它服务管理'},
      { id: powerMap.log_shengcha, label: '服务日志审计'},
    ]
  },
  {id: 'Lose6',label: '扶贫车间',
    children: [
      { id: 'Lose6_1', label: '就业扶贫车间基本情况汇总表权限管理', children:[
        // {id:powerMap.form_jyfpcjjbqkzb, label:'就业扶贫车间基本情况汇总表'},
        {id:powerMap.form_jyfpcjjbqkzb+'-search', label:'就业扶贫车间基本情况汇总表查询'},
        {id:powerMap.form_jyfpcjjbqkzb+'-modify', label:'就业扶贫车间基本情况汇总表修改'},
        {id:powerMap.form_jyfpcjjbqkzb+'-delete', label:'就业扶贫车间基本情况汇总表删除'},
        {id:powerMap.form_jyfpcjjbqkzb+'-create', label:'就业扶贫车间基本情况汇总表创建'},
        {id:powerMap.form_jyfpcjjbqkzb+'-import', label:'就业扶贫车间基本情况汇总表导入'},
        {id:powerMap.form_jyfpcjjbqkzb+'-export', label:'就业扶贫车间基本情况汇总表导出'},
      ]},
      { id: 'Lose6_2', label: '就业扶贫车间吸纳就业名册汇总表权限管理', children:[
        // {id:powerMap.form_jyfpcjxnjymc, label:'就业扶贫车间吸纳就业名册汇总表'},
        {id:powerMap.form_jyfpcjxnjymc+'-search', label:'就业扶贫车间吸纳就业名册汇总表查询'},
        {id:powerMap.form_jyfpcjxnjymc+'-modify', label:'就业扶贫车间吸纳就业名册汇总表修改'},
        {id:powerMap.form_jyfpcjxnjymc+'-delete', label:'就业扶贫车间吸纳就业名册汇总表删除'},
        {id:powerMap.form_jyfpcjxnjymc+'-create', label:'就业扶贫车间吸纳就业名册汇总表创建'},
        {id:powerMap.form_jyfpcjxnjymc+'-import', label:'就业扶贫车间吸纳就业名册汇总表导入'},
        {id:powerMap.form_jyfpcjxnjymc+'-export', label:'就业扶贫车间吸纳就业名册汇总表导出'},
      ]},
      { id: 'Lose6_3', label: '就业扶贫车间动态管理台帐权限管理', children:[
        // {id:powerMap.form_jyfpcjdtgl, label:'就业扶贫车间动态管理台帐'},
        {id:powerMap.form_jyfpcjdtgl+'-search', label:'就业扶贫车间动态管理台帐查询'},
        {id:powerMap.form_jyfpcjdtgl+'-modify', label:'就业扶贫车间动态管理台帐修改'},
        {id:powerMap.form_jyfpcjdtgl+'-delete', label:'就业扶贫车间动态管理台帐删除'},
        {id:powerMap.form_jyfpcjdtgl+'-create', label:'就业扶贫车间动态管理台帐创建'},
        {id:powerMap.form_jyfpcjdtgl+'-import', label:'就业扶贫车间动态管理台帐导入'},
        {id:powerMap.form_jyfpcjdtgl+'-export', label:'就业扶贫车间动态管理台帐导出'},
      ]},
      { id: 'Lose6_4', label: '吸纳贫困劳动力就业动态监管台账权限管理', children:[
        // {id:powerMap.form_xnpkldljydtjgtz, label:'吸纳贫困劳动力就业动态监管台账'},
        {id:powerMap.form_xnpkldljydtjgtz+'-search', label:'吸纳贫困劳动力就业动态监管台账查询'},
        {id:powerMap.form_xnpkldljydtjgtz+'-modify', label:'吸纳贫困劳动力就业动态监管台账修改'},
        {id:powerMap.form_xnpkldljydtjgtz+'-delete', label:'吸纳贫困劳动力就业动态监管台账删除'},
        {id:powerMap.form_xnpkldljydtjgtz+'-create', label:'吸纳贫困劳动力就业动态监管台账创建'},
        {id:powerMap.form_xnpkldljydtjgtz+'-import', label:'吸纳贫困劳动力就业动态监管台账导入'},
        {id:powerMap.form_xnpkldljydtjgtz+'-export', label:'吸纳贫困劳动力就业动态监管台账导出'},
      ]},
      { id: 'Lose6_5', label: '吸纳易地变迁贫困劳动力就业名册权限管理', children:[
        // {id:powerMap.form_xnydbqpkndl, label:'吸纳易地变迁贫困劳动力就业名册'},
        {id:powerMap.form_xnydbqpkndl+'-search', label:'吸纳易地变迁贫困劳动力就业名册查询'},
        {id:powerMap.form_xnydbqpkndl+'-modify', label:'吸纳易地变迁贫困劳动力就业名册修改'},
        {id:powerMap.form_xnydbqpkndl+'-delete', label:'吸纳易地变迁贫困劳动力就业名册删除'},
        {id:powerMap.form_xnydbqpkndl+'-create', label:'吸纳易地变迁贫困劳动力就业名册创建'},
        {id:powerMap.form_xnydbqpkndl+'-import', label:'吸纳易地变迁贫困劳动力就业名册导入'},
        {id:powerMap.form_xnydbqpkndl+'-export', label:'吸纳易地变迁贫困劳动力就业名册导出'},
      ]},
    ]
  },
  {id: 'Lose8',label: '培训服务',
    children: [
      { id: powerMap.study, label: '培训'},
      { id: powerMap.studyUpload, label: '培训上传'},
      { id: powerMap.studyApply, label: '培训申请'},
      { id: powerMap.studyExamine, label: '培训审核'},
      { id: powerMap.studyList, label: '培训列表'},
    ]
  },
  {id: 'Lose9',label: '企业服务',
    children: [
      { id: 'Lose9_0', label: '企业申请审核管理', children:[
        // {id:powerMap.companyApply, label:'企业申请审核'},
        // {id:powerMap.companyApply+'-search', label:'企业申请审核查询'},
        {id:powerMap.companyApply+'-modify', label:'企业申请审核修改'},
        {id:powerMap.companyApply+'-delete', label:'企业申请审核删除'},
        // {id:powerMap.companyApply+'-create', label:'企业申请审核创建'},
        // {id:powerMap.companyApply+'-import', label:'企业申请审核导入'},
        // {id:powerMap.companyApply+'-export', label:'企业申请审核导出'},
      ]},
      { id: 'Lose9_13', label: '教育权限管理', children:[
        // {id:powerMap.jiaoyu, label:'教育'},
        {id:powerMap.jiaoyu+'-search', label:'教育查询'},
        {id:powerMap.jiaoyu+'-modify', label:'教育修改'},
        {id:powerMap.jiaoyu+'-delete', label:'教育删除'},
        {id:powerMap.jiaoyu+'-create', label:'教育创建'},
        {id:powerMap.jiaoyu+'-import', label:'教育导入'},
        {id:powerMap.jiaoyu+'-export', label:'教育导出'},
      ]},
      { id: 'Lose9_14', label: '培训权限管理', children:[
        // {id:powerMap.peixun, label:'培训'},
        {id:powerMap.peixun+'-search', label:'培训查询'},
        {id:powerMap.peixun+'-modify', label:'培训修改'},
        {id:powerMap.peixun+'-delete', label:'培训删除'},
        {id:powerMap.peixun+'-create', label:'培训创建'},
        {id:powerMap.peixun+'-import', label:'培训导入'},
        {id:powerMap.peixun+'-export', label:'培训导出'},
      ]},
      { id: 'Lose9_1', label: '招商权限管理', children:[
        // {id:powerMap.zhaoshang, label:'招商'},
        {id:powerMap.zhaoshang+'-search', label:'招商查询'},
        {id:powerMap.zhaoshang+'-modify', label:'招商修改'},
        {id:powerMap.zhaoshang+'-delete', label:'招商删除'},
        {id:powerMap.zhaoshang+'-create', label:'招商创建'},
        {id:powerMap.zhaoshang+'-import', label:'招商导入'},
        {id:powerMap.zhaoshang+'-export', label:'招商导出'},
      ]},
      { id: 'Lose9_2', label: '加盟权限管理', children:[
        // {id:powerMap.jiameng, label:'加盟'},
        {id:powerMap.jiameng+'-search', label:'加盟查询'},
        {id:powerMap.jiameng+'-modify', label:'加盟修改'},
        {id:powerMap.jiameng+'-delete', label:'加盟删除'},
        {id:powerMap.jiameng+'-create', label:'加盟创建'},
        {id:powerMap.jiameng+'-import', label:'加盟导入'},
        {id:powerMap.jiameng+'-export', label:'加盟导出'},
      ]},
      { id: 'Lose9_3', label: '融资权限管理', children:[
        // {id:powerMap.rongzi, label:'融资'},
        {id:powerMap.rongzi+'-search', label:'融资查询'},
        {id:powerMap.rongzi+'-modify', label:'融资修改'},
        {id:powerMap.rongzi+'-delete', label:'融资删除'},
        {id:powerMap.rongzi+'-create', label:'融资创建'},
        {id:powerMap.rongzi+'-import', label:'融资导入'},
        {id:powerMap.rongzi+'-export', label:'融资导出'},
      ]},
      { id: 'Lose9_4', label: '投资权限管理', children:[
        // {id:powerMap.touzi, label:'投资'},
        {id:powerMap.touzi+'-search', label:'投资查询'},
        {id:powerMap.touzi+'-modify', label:'投资修改'},
        {id:powerMap.touzi+'-delete', label:'投资删除'},
        {id:powerMap.touzi+'-create', label:'投资创建'},
        {id:powerMap.touzi+'-import', label:'投资导入'},
        {id:powerMap.touzi+'-export', label:'投资导出'},
      ]},
      { id: 'Lose9_5', label: '租房权限管理', children:[
        // {id:powerMap.zufang, label:'租房'},
        {id:powerMap.zufang+'-search', label:'租房查询'},
        {id:powerMap.zufang+'-modify', label:'租房修改'},
        {id:powerMap.zufang+'-delete', label:'租房删除'},
        {id:powerMap.zufang+'-create', label:'租房创建'},
        {id:powerMap.zufang+'-import', label:'租房导入'},
        {id:powerMap.zufang+'-export', label:'租房导出'},
      ]},
      { id: 'Lose9_6', label: '售房权限管理', children:[
        // {id:powerMap.shoufang, label:'售房'},
        {id:powerMap.shoufang+'-search', label:'售房查询'},
        {id:powerMap.shoufang+'-modify', label:'售房修改'},
        {id:powerMap.shoufang+'-delete', label:'售房删除'},
        {id:powerMap.shoufang+'-create', label:'售房创建'},
        {id:powerMap.shoufang+'-import', label:'售房导入'},
        {id:powerMap.shoufang+'-export', label:'售房导出'},
      ]},
      { id: 'Lose9_7', label: '汽车权限管理', children:[
        // {id:powerMap.qiche, label:'汽车'},
        {id:powerMap.qiche+'-search', label:'汽车查询'},
        {id:powerMap.qiche+'-modify', label:'汽车修改'},
        {id:powerMap.qiche+'-delete', label:'汽车删除'},
        {id:powerMap.qiche+'-create', label:'汽车创建'},
        {id:powerMap.qiche+'-import', label:'汽车导入'},
        {id:powerMap.qiche+'-export', label:'汽车导出'},
      ]},
      // { id: 'Lose9_8', label: '交友权限管理', children:[
      //   // {id:powerMap.jiaoyou'', label:'交友'},
      //   {id:powerMap.jiaoyou'-search', label:'交友查询'},
      //   {id:powerMap.jiaoyou'-modify', label:'交友修改'},
      //   {id:powerMap.jiaoyou'-delete', label:'交友删除'},
      //   {id:powerMap.jiaoyou'-create', label:'交友创建'},
      //   {id:powerMap.jiaoyou'-import', label:'交友导入'},
      //   {id:powerMap.jiaoyou'-export', label:'交友导出'},
      // ]},
      { id: 'Lose9_9', label: '电商权限管理', children:[
        // {id:powerMap.gouwu, label:'电商'},
        {id:powerMap.gouwu+'-search', label:'电商查询'},
        {id:powerMap.gouwu+'-modify', label:'电商修改'},
        {id:powerMap.gouwu+'-delete', label:'电商删除'},
        {id:powerMap.gouwu+'-create', label:'电商创建'},
        {id:powerMap.gouwu+'-import', label:'电商导入'},
        {id:powerMap.gouwu+'-export', label:'电商导出'},
      ]},
      { id: 'Lose9_10', label: '美食权限管理', children:[
        // {id:powerMap.meishi, label:'美食'},
        {id:powerMap.meishi+'-search', label:'美食查询'},
        {id:powerMap.meishi+'-modify', label:'美食修改'},
        {id:powerMap.meishi+'-delete', label:'美食删除'},
        {id:powerMap.meishi+'-create', label:'美食创建'},
        {id:powerMap.meishi+'-import', label:'美食导入'},
        {id:powerMap.meishi+'-export', label:'美食导出'},
      ]},
      { id: 'Lose9_11', label: '旅游权限管理', children:[
        // {id:powerMap.lvyou, label:'旅游'},
        {id:powerMap.lvyou+'-search', label:'旅游查询'},
        {id:powerMap.lvyou+'-modify', label:'旅游修改'},
        {id:powerMap.lvyou+'-delete', label:'旅游删除'},
        {id:powerMap.lvyou+'-create', label:'旅游创建'},
        {id:powerMap.lvyou+'-import', label:'旅游导入'},
        {id:powerMap.lvyou+'-export', label:'旅游导出'},
      ]},
      { id: 'Lose9_12', label: '健康权限管理', children:[
        // {id:powerMap.jiankang, label:'健康'},
        {id:powerMap.jiankang+'-search', label:'健康查询'},
        {id:powerMap.jiankang+'-modify', label:'健康修改'},
        {id:powerMap.jiankang+'-delete', label:'健康删除'},
        {id:powerMap.jiankang+'-create', label:'健康创建'},
        {id:powerMap.jiankang+'-import', label:'健康导入'},
        {id:powerMap.jiankang+'-export', label:'健康导出'},
      ]},
    ]
  },
  {id: 'Lose10',label: '法律维权',
    children: [
      { id: 'Lose10_1', label: '法律咨询', children:[
        {id:powerMap.flzx+'-search', label:'法律咨询查询'},
        {id:powerMap.flzx+'-modify', label:'法律咨询修改'},
        {id:powerMap.flzx+'-delete', label:'法律咨询删除'},
      ]}, { id: 'Lose10_2', label: '案件委托', children:[
        {id:powerMap.ajwt+'-search', label:'案件委托查询'},
        {id:powerMap.ajwt+'-modify', label:'案件委托修改'},
        {id:powerMap.ajwt+'-delete', label:'案件委托删除'},
      ]}, { id: 'Lose10_3', label: '律师申请',children:[
        {id:powerMap.layerApply, label:'律师申请审核'},
      ]}
    ]
  },
  {id: 'Lose11',label: '信息发布',
    children: [
      { id: powerMap.briefIntroduction, label: '关于竞成'},
      { id: powerMap.idea, label: '竞成理念'},
      { id: powerMap.culture, label: '竞成文化'},
      { id: powerMap.team, label: '竞成团队'},
      { id: powerMap.routeLine, label: '竞成之路'},
      { id: powerMap.contactUs, label: '联系我们'},
      { id: powerMap.news, label: '竞成新闻'},
      { id: powerMap.activity, label: '竞成活动'},
      { id: powerMap.overallArticle, label: '全局新闻'},
    ]
  },
  {id: 'Lose12',label: '人事人才',
    children:[
      {id: 'Lose12_0',label: '轮播管理',children:[
        {id:powerMap.banner_rs, label:'轮播管理查询'},
        {id:powerMap.banner_rs+'-modify', label:'轮播管理修改'},
        {id:powerMap.banner_rs+'-delete', label:'轮播管理删除'},
        {id:powerMap.banner_rs+'-create', label:'轮播管理创建'},
      ]}, {id: 'Lose12_1',label: '人事招考',children:[
        {id:powerMap.examination, label:'人事招考查询'},
        {id:powerMap.examination+'-modify', label:'人事招考修改'},
        {id:powerMap.examination+'-delete', label:'人事招考删除'},
        {id:powerMap.examination+'-create', label:'人事招考创建'},
      ]}, {id: 'Lose12_2',label: '人事档案',children:[
        {id:powerMap.archives, label:'人事档案查询'},
        {id:powerMap.archives+'-create', label:'人事档案修改'},
        {id:powerMap.archives+'-delete', label:'人事档案删除'},
        {id:powerMap.archives+'-modify', label:'人事档案创建'},
      ]}, {id: 'Lose12_3',label: '人事信息',children:[
        {id:powerMap.information, label:'人事信息查询'},
        {id:powerMap.information+'-create', label:'人事信息修改'},
        {id:powerMap.information+'-delete', label:'人事信息删除'},
        {id:powerMap.information+'-modify', label:'人事信息创建'},
      ]}, {id: 'Lose12_4',label: '人事培训',children:[
        {id:powerMap.train, label:'人事培训查询'},
        {id:powerMap.train+'-create', label:'人事培训修改'},
        {id:powerMap.train+'-delete', label:'人事培训删除'},
        {id:powerMap.train+'-modify', label:'人事培训创建'},
      ]}, {id: 'Lose12_5',label: '才事预告',children:[
        {id:powerMap.notice, label:'才事预告查询'},
        {id:powerMap.notice+'-modify', label:'才事预告修改'},
        {id:powerMap.notice+'-delete', label:'才事预告删除'},
        {id:powerMap.notice+'-create', label:'才事预告创建'},
      ]}, {id: 'Lose12_6',label: '现场招聘',children:[
        {id:powerMap.scene, label:'现场招聘查询'},
        {id:powerMap.scene+'-modify', label:'现场招聘修改'},
        {id:powerMap.scene+'-delete', label:'现场招聘删除'},
        {id:powerMap.scene+'-create', label:'现场招聘创建'},
      ]}, {id: 'Lose12_7',label: '视频招聘',children:[
        {id:powerMap.video, label:'视频招聘查询'},
        {id:powerMap.video+'-modify', label:'视频招聘修改'},
        {id:powerMap.video+'-delete', label:'视频招聘删除'},
        {id:powerMap.video+'-create', label:'视频招聘创建'},
      ]}, {id: 'Lose12_8',label: '在线访谈',children:[
        {id:powerMap.interview, label:'在线访谈查询'},
        {id:powerMap.interview+'-modify', label:'在线访谈修改'},
        {id:powerMap.interview+'-interview-delete', label:'在线访谈删除'},
        {id:powerMap.interview+'-create', label:'在线访谈创建'},
      ]}, {id: 'Lose12_9',label: '访谈预告',children:[
        {id:powerMap.interviewNotice, label:'访谈预告查询'},
        {id:powerMap.interviewNotice+'-modify', label:'访谈预告修改'},
        {id:powerMap.interviewNotice+'-delete', label:'访谈预告删除'},
        {id:powerMap.interviewNotice+'-create', label:'访谈预告创建'},
      ]}, {id: 'Lose12_10',label: '访谈录播',children:[
        {id:powerMap.interviewRecording, label:'访谈录播查询'},
        {id:powerMap.interviewRecording+'-modify', label:'访谈录播修改'},
        {id:powerMap.interviewRecording+'-delete', label:'访谈录播删除'},
        {id:powerMap.interviewRecording+'-create', label:'访谈录播创建'},
      ]}, {id: 'Lose12_11',label: '百事通',children:[
        {id:powerMap.leaderEmail+'-anything', label:'百事通查询'},
        {id:powerMap.leaderEmail+'-modify', label:'百事通修改'},
        {id:powerMap.leaderEmail+'-deletey', label:'百事通删除'},
        {id:powerMap.leaderEmail+'-create', label:'百事通创建'},
      ]}, {id: 'Lose12_12',label: '领导信箱',children:[
        {id:powerMap.knowAll, label:'领导信箱查询'},
        {id:powerMap.knowAll+'-modify', label:'领导信箱修改'},
        // {powerMap.knowAll+i-email-delete', label:'领导信箱删除'},
        {id:powerMap.knowAll+'-create', label:'领导信箱创建'},
      ]}, {id: 'Lose12_13',label: '新闻中心',children:[
        {id:powerMap.newsCenter, label:'新闻中心查询'},
        {id:powerMap.newsCenter+'-modify', label:'新闻中心修改'},
        {id:powerMap.newsCenter+'-delete', label:'新闻中心删除'},
        {id:powerMap.newsCenter+'-create', label:'新闻中心创建'},
      ]},
    ]
  },
  {id: 'Lose13',label: '系统设置',
    children: [
      { id: powerMap.logo, label: '系统名称与LOGO'},
      { id: powerMap.mapSet, label: '系统地图设置'},
      { id: powerMap.mapView, label: '查看地图'},
      { id: powerMap.areaedit, label: '系统地区设置'},
      { id: powerMap.setKeyWord, label: '评论敏感词设置'},
      // { id: powerMap.setSitePower, label: '站点管理权限'},
      { id: powerMap.fenzhan, label: '创建用户'},
      { id: powerMap.delUser, label: '删除用户'},
      { id: powerMap.power, label: '权限设置'},
      { id: powerMap.zhiding, label: '置顶权重设置'},
      { id: powerMap.setVip, label: 'vip设置'},
      { id: powerMap.vip+'-modify', label: 'vip申请审核'},
      { id: powerMap.vip+'-delete', label: 'vip申请删除'},
      { id: powerMap.userInfo, label: '账号信息修改'},
      { id: powerMap.zhengce, label: '政策法规'},
      { id: powerMap.renshe, label: '人社业务'},
    ]
  },
  {id: 'Lose14',label: '招聘求职',
    children: [
      { id: powerMap.mianshi, label: '查看面试邀请'},
      { id: powerMap.jianli, label: '查看到收到简历'},
    ]
  },
  {id: 'Lose15',label: '交流投诉',
    children: [
      {id: 'Lose15_1',label: '交流权限管理',children:[
        {id:powerMap.hudong+'-search', label:'交流查询'},
        {id:powerMap.hudong+'-modify', label:'交流修改'},
        {id:powerMap.hudong+'-delete', label:'交流删除'},
      ]},
      {id: 'Lose15_2',label: '投诉权限管理',children:[
        {id:powerMap.tousu+'-search', label:'投诉查询'},
        {id:powerMap.tousu+'-modify', label:'投诉修改'},
        {id:powerMap.tousu+'-delete', label:'投诉删除'},
      ]},
    ]
  },
  {id: 'Lose16',label: '分配任务',
    children: [
      {id: powerMap.fenpeigeren,label: '分配个人信息'},
      {id: powerMap.fenpeiqiye,label: '分配企业信息'},
    ]
  },
  {id: 'Lose17',label: '工作人员',
    children: [
      {id: powerMap.fapiao,label: '发票管理'},
    ]
  },
  {id: 'Lose18',label: '个人社保',
    children: [
      {id: 'Lose18_1',label: '个人社保管理',
        children: [
          // {id: powerMap.shebao_geren,label: '个人社保信息管理'},
          {id: powerMap.shebao_geren+'-search',label: '个人社保信息管理查询'},
          {id: powerMap.shebao_geren+'-create',label: '个人社保信息管理创建'},
          {id: powerMap.shebao_geren+'-modify',label: '个人社保信息管理修改'},
          {id: powerMap.shebao_geren+'-import',label: '个人社保信息管理导入'},
          {id: powerMap.shebao_geren+'-delete',label: '个人社保信息管理删除'},
          {id: powerMap.shebao_geren+'-export',label: '个人社保信息管理导出'},
        ]
      },
      {id: 'Lose18_2',label: '未转移社保管理',
        children: [
          // {id: powerMap.shebao_weizhuanyi,label: '未转移社保'},
          {id: powerMap.shebao_weizhuanyi+'-search',label: '未转移社保查询'},
          {id: powerMap.shebao_weizhuanyi+'-create',label: '未转移社保创建'},
          {id: powerMap.shebao_weizhuanyi+'-modify',label: '未转移社保修改'},
          {id: powerMap.shebao_weizhuanyi+'-import',label: '未转移社保导入'},
          {id: powerMap.shebao_weizhuanyi+'-delete',label: '未转移社保删除'},
          {id: powerMap.shebao_weizhuanyi+'-export',label: '未转移社保导出'},
        ]
      },
      {id: 'Lose18_3',label: '社保补缴费管理',
        children: [
          // {id: powerMap.shebao_bujiaofei,label: '社保补缴费管理'},
          {id: powerMap.shebao_bujiaofei+'-search',label: '社保补缴费管理查询'},
          {id: powerMap.shebao_bujiaofei+'-create',label: '社保补缴费管理创建'},
          {id: powerMap.shebao_bujiaofei+'-modify',label: '社保补缴费管理修改'},
          {id: powerMap.shebao_bujiaofei+'-import',label: '社保补缴费管理导入'},
          {id: powerMap.shebao_bujiaofei+'-delete',label: '社保补缴费管理删除'},
          {id: powerMap.shebao_bujiaofei+'-export',label: '社保补缴费管理导出'},
        ]
      },
      {id: 'Lose18_4',label: '缴纳情况管理',
        children: [
          // {id: powerMap.shebao_jiaona,label: '缴纳情况'},
          {id: powerMap.shebao_jiaona+'-search',label: '缴纳情况查询'},
          {id: powerMap.shebao_jiaona+'-create',label: '缴纳情况创建'},
          {id: powerMap.shebao_jiaona+'-modify',label: '缴纳情况修改'},
          {id: powerMap.shebao_jiaona+'-import',label: '缴纳情况导入'},
          {id: powerMap.shebao_jiaona+'-delete',label: '缴纳情况删除'},
          {id: powerMap.shebao_jiaona+'-export',label: '缴纳情况导出'},
        ]
      },
      {id: 'Lose18_5',label: '社保退费管理',
        children: [
          // {id: powerMap.shebao_tuifei,label: '社保退费'},
          {id: powerMap.shebao_tuifei+'-search',label: '社保退费查询'},
          {id: powerMap.shebao_tuifei+'-create',label: '社保退费创建'},
          {id: powerMap.shebao_tuifei+'-modify',label: '社保退费修改'},
          {id: powerMap.shebao_tuifei+'-import',label: '社保退费导入'},
          {id: powerMap.shebao_tuifei+'-delete',label: '社保退费删除'},
          {id: powerMap.shebao_tuifei+'-export',label: '社保退费导出'},
          {id: powerMap.shebao_tuifei+'-unpaylist',label: '未交社保导出'},
          {id: powerMap.shebao_tuifei+'-fullYear',label: '退费列表导出'},
        ]
      },
    ]
  },
  {id: 'Lose19',label: '人力资源',
    children: [
      {id: 'Lose19_1',label: '关联企业管理',
        children: [
          // {id: powerMap.rlzy_guanlian_qiye,label: '关联企业管理'},
          // {id: powerMap.rlzy_guanlian_qiye+'-search',label: '关联企业管理查询'},
          {id: powerMap.rlzy_guanlian_qiye+'-create',label: '关联企业管理创建'},
          // {id: powerMap.rlzy_guanlian_qiye+'-modify',label: '关联企业管理修改'},
          {id: powerMap.rlzy_guanlian_qiye+'-import',label: '关联企业管理导入'},
          {id: powerMap.rlzy_guanlian_qiye+'-delete',label: '关联企业管理删除'},
          // {id: powerMap.rlzy_guanlian_qiye+'-export',label: '关联企业管理导出'},
          {id: powerMap.rlzy_guanlian_hetong+'-create',label: '企业合同创建'},
          {id: powerMap.rlzy_guanlian_hetong+'-modify',label: '企业合同修改'},
          {id: powerMap.rlzy_guanlian_hetong+'-import',label: '企业合同导入'},
          {id: powerMap.rlzy_guanlian_hetong+'-delete',label: '企业合同删除'},
          {id: powerMap.rlzy_guanlian_hetong+'-export',label: '企业合同导出'},
        ]
      }, {id: 'Lose19_2',label: '关联个人管理',
        children: [
          // {id: powerMap.rlzy_guanlian_geren,label: '关联个人管理'},
          // {id: powerMap.rlzy_guanlian_geren+'-search',label: '关联个人管理查询'},
          {id: powerMap.rlzy_guanlian_geren+'-create',label: '关联个人管理创建'},
          // {id: powerMap.rlzy_guanlian_geren+'-modify',label: '关联个人管理修改'},
          {id: powerMap.rlzy_guanlian_geren+'-import',label: '关联个人管理导入'},
          {id: powerMap.rlzy_guanlian_geren+'-delete',label: '关联个人管理删除'},
          // {id: powerMap.rlzy_guanlian_geren+'-export',label: '关联个人管理导出'},
          {id: powerMap.rlzy_guanlian_gerenhetong+'-create',label: '个人合同创建'},
          {id: powerMap.rlzy_guanlian_gerenhetong+'-modify',label: '个人合同修改'},
          {id: powerMap.rlzy_guanlian_gerenhetong+'-import',label: '个人合同导入'},
          {id: powerMap.rlzy_guanlian_gerenhetong+'-delete',label: '个人合同删除'},
          {id: powerMap.rlzy_guanlian_gerenhetong+'-export',label: '个人合同导出'},
        ]
      }, {id: 'Lose19_3',label: '费用核算登记',
        children: [
          // {id: powerMap.rlzy_dengji_hesuan,label: '费用核算登记'},
          // {id: powerMap.rlzy_dengji_hesuan+'-search',label: '费用核算登记查询'},
          {id: powerMap.rlzy_dengji_hesuan+'-create',label: '费用核算登记创建'},
          {id: powerMap.rlzy_dengji_hesuan+'-modify',label: '费用核算登记修改'},
          {id: powerMap.rlzy_dengji_hesuan+'-import',label: '费用核算登记导入'},
          {id: powerMap.rlzy_dengji_hesuan+'-delete',label: '费用核算登记删除'},
          {id: powerMap.rlzy_dengji_hesuan+'-export',label: '费用核算登记导出'},
        ]
      }, {id: 'Lose19_4',label: '开票登记',
        children: [
          // {id: powerMap.rlzy_dengji_kaipiao,label: '开票登记'},
          // {id: powerMap.rlzy_dengji_kaipiao+'-search',label: '开票登记查询'},
          {id: powerMap.rlzy_dengji_kaipiao+'-create',label: '开票登记创建'},
          {id: powerMap.rlzy_dengji_kaipiao+'-modify',label: '开票登记修改'},
          {id: powerMap.rlzy_dengji_kaipiao+'-import',label: '开票登记导入'},
          {id: powerMap.rlzy_dengji_kaipiao+'-delete',label: '开票登记删除'},
          {id: powerMap.rlzy_dengji_kaipiao+'-export',label: '开票登记导出'},
        ]
      }, {id: 'Lose19_5',label: '到账登记',
        children: [
          // {id: powerMap.rlzy_dengji_daozhang,label: '到账登记'},
          // {id: powerMap.rlzy_dengji_daozhang+'-search',label: '到账登记查询'},
          {id: powerMap.rlzy_dengji_daozhang+'-create',label: '到账登记创建'},
          {id: powerMap.rlzy_dengji_daozhang+'-modify',label: '到账登记修改'},
          {id: powerMap.rlzy_dengji_daozhang+'-import',label: '到账登记导入'},
          {id: powerMap.rlzy_dengji_daozhang+'-delete',label: '到账登记删除'},
          {id: powerMap.rlzy_dengji_daozhang+'-export',label: '到账登记导出'},
        ]
      },
    ]
  },
  {id: 'Lose20',label: '建筑工地',
    children: [
      {id: 'Lose20_1',label: '劳动用工备案',
        children: [
          // {id: powerMap.jzgd_yonggongbeian,label: '劳动用工备案'},
          // {id: powerMap.jzgd_yonggongbeian+'-search',label: '劳动用工备案查询'},
          {id: powerMap.jzgd_yonggongbeian+'-create',label: '劳动用工备案创建'},
          {id: powerMap.jzgd_yonggongbeian+'-modify',label: '劳动用工备案修改'},
          {id: powerMap.jzgd_yonggongbeian+'-import',label: '劳动用工备案导入'},
          {id: powerMap.jzgd_yonggongbeian+'-delete',label: '劳动用工备案删除'},
          {id: powerMap.jzgd_yonggongbeian+'-export',label: '劳动用工备案导出'},
        ]
      }, {id: 'Lose20_2',label: '在线求助',
        children: [
          // {id: powerMap.jzgd_zaixianqiuzhu,label: '在线求助管理'},
          {id: powerMap.jzgd_zaixianqiuzhu+'-search',label: '在线求助管理查询'},
          // {id: powerMap.jzgd_zaixianqiuzhu+'-create',label: '在线求助管理创建'},
          {id: powerMap.jzgd_zaixianqiuzhu+'-modify',label: '在线求助管理修改'},
          // {id: powerMap.jzgd_zaixianqiuzhu+'-import',label: '在线求助管理导入'},
          {id: powerMap.jzgd_zaixianqiuzhu+'-delete',label: '在线求助管理删除'},
          // {id: powerMap.jzgd_zaixianqiuzhu+'-export',label: '在线求助管理导出'},
        ]
      },
    ]
  },
  {id: 'Lose21',label: '法律援助',
    children: [
      {id: 'Lose21_1',label: '委托合同',
        children: [
          // {id: powerMap.yz_wt_weituo,label: '委托合同'},
          {id: powerMap.yz_wt_weituo+'-search',label: '委托合同查询'},
          {id: powerMap.yz_wt_weituo+'-create',label: '委托合同创建'},
          {id: powerMap.yz_wt_weituo+'-modify',label: '委托合同修改'},
          // {id: powerMap.yz_wt_weituo+'-import',label: '委托合同导入'},
          {id: powerMap.yz_wt_weituo+'-delete',label: '委托合同删除'},
          // {id: powerMap.yz_wt_weituo+'-export',label: '委托合同导出'},
        ]
      }, {id: 'Lose21_2',label: '发票申请',
        children: [
          // {id: powerMap.yz_wt_fapiao,label: '发票申请'},
          // {id: powerMap.yz_wt_fapiao+'-search',label: '发票申请查询'},
          // {id: powerMap.yz_wt_fapiao+'-create',label: '发票申请创建'},
          {id: powerMap.yz_wt_fapiao+'-modify',label: '发票申请修改'},
          // {id: powerMap.yz_wt_fapiao+'-import',label: '发票申请导入'},
          {id: powerMap.yz_wt_fapiao+'-delete',label: '发票申请删除'},
          // {id: powerMap.yz_wt_fapiao+'-export',label: '发票申请导出'},
        ]
      }, {id: 'Lose21_3',label: '案件进展',
        children: [
          // {id: powerMap.yz_ss_jinzhan,label: '案件进展'},
          {id: powerMap.yz_ss_jinzhan+'-search',label: '案件进展查询'},
          {id: powerMap.yz_ss_jinzhan+'-create',label: '案件进展创建'},
          {id: powerMap.yz_ss_jinzhan+'-modify',label: '案件进展修改'},
          // {id: powerMap.yz_ss_jinzhan+'-import',label: '案件进展导入'},
          {id: powerMap.yz_ss_jinzhan+'-delete',label: '案件进展删除'},
          // {id: powerMap.yz_ss_jinzhan+'-export',label: '案件进展导出'},
        ]
      }, {id: 'Lose21_4',label: '法律文书',
        children: [
          // {id: powerMap.yz_ws_zhengju,label: '法律文书'},
          {id: powerMap.yz_ws_zhengju+'-search',label: '法律文书查询'},
          {id: powerMap.yz_ws_zhengju+'-create',label: '法律文书创建'},
          {id: powerMap.yz_ws_zhengju+'-modify',label: '法律文书修改'},
          // {id: powerMap.yz_ws_zhengju+'-import',label: '法律文书导入'},
          {id: powerMap.yz_ws_zhengju+'-delete',label: '法律文书删除'},
          // {id: powerMap.yz_ws_zhengju+'-export',label: '法律文书导出'},
        ]
      },
    ]
  },
  // {id: 'Lose18',label: '快速求职',
  //   children: [
  //     {id: powerMap.quickqiuzhi,label: '快速求职'},
  //   ]
  // },
]

export { powerData, powerMap }